var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "save-state-row" }, [
      _c("span", { staticClass: "save-state-label" }, [_vm._v("Auto save")]),
      _c("span", { staticClass: "save-state", class: _vm.saveStateClass }, [
        _vm._v(" " + _vm._s(_vm.saveStateText) + " "),
      ]),
    ]),
    _c("div", { staticClass: "table-responsive config-list-table" }, [
      _c("table", { staticClass: "table" }, [
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("เวลาสำหรับการเล่นแต่ละครั้ง"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.play_sec,
                  expression: "localForm.play_sec",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "0", max: "100" },
              domProps: { value: _vm.localForm.play_sec },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "play_sec",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("วินาที")]
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("คะแนนสำหรับ SKU1"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.point_0,
                  expression: "localForm.point_0",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "0", max: "100" },
              domProps: { value: _vm.localForm.point_0 },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "point_0",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("คะแนน")]
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("คะแนนสำหรับ SKU2"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.point_1,
                  expression: "localForm.point_1",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "0", max: "100" },
              domProps: { value: _vm.localForm.point_1 },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "point_1",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("คะแนน")]
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("คะแนนสำหรับ SKU3"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.point_2,
                  expression: "localForm.point_2",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "0", max: "100" },
              domProps: { value: _vm.localForm.point_2 },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "point_2",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("คะแนน")]
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("คะแนนสำหรับ VIP"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.point_vip,
                  expression: "localForm.point_vip",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "0", max: "100" },
              domProps: { value: _vm.localForm.point_vip },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "point_vip",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("คะแนน")]
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-middle" }, [
            _vm._v("คะแนนสำหรับระเบิด"),
          ]),
          _c("td", { attrs: { width: "100", align: "right" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.localForm.point_bomb,
                  expression: "localForm.point_bomb",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "-100", max: "0" },
              domProps: { value: _vm.localForm.point_bomb },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.localForm,
                      "point_bomb",
                      _vm._n($event.target.value)
                    )
                  },
                  _vm.onFieldInput,
                ],
                blur: [
                  _vm.onFieldBlur,
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
              },
            }),
          ]),
          _c(
            "td",
            {
              staticClass: "align-middle",
              attrs: { width: "80", align: "left" },
            },
            [_vm._v("คะแนน")]
          ),
        ]),
      ]),
    ]),
    _c("hr"),
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-between align-items-center mb-20 theme-row",
      },
      [
        _c("h4", { staticClass: "mb-0" }, [_vm._v("Theme")]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localForm.theme_id,
                expression: "localForm.theme_id",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control w-250",
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return _vm._n(val)
                    })
                  _vm.$set(
                    _vm.localForm,
                    "theme_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                _vm.onFieldBlur,
              ],
            },
          },
          _vm._l(_vm.themes, function (theme) {
            return _c(
              "option",
              { key: theme.id, domProps: { value: theme.id } },
              [_vm._v(" " + _vm._s(" " + theme.id + " - " + theme.name) + " ")]
            )
          }),
          0
        ),
      ]
    ),
    _c("hr"),
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-between align-items-start no-play-row",
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "table-days-point-wrapper" }, [
          _c("table", [
            _c(
              "tr",
              _vm._l(_vm.days, function (day, index) {
                return _c("td", { key: index }, [
                  _c("p", [_vm._v(_vm._s(day.text))]),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      min: "0",
                      max: "999",
                      type: "number",
                      disabled: "",
                    },
                    domProps: { value: _vm.localForm[day.key] },
                  }),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", { staticClass: "mb-5" }, [_vm._v("No. play per day")]),
      _c("p", { staticClass: "text-help" }, [
        _vm._v(" สำหรับ Ufu ส่วนนี้แสดงค่าเดิมและไม่อนุญาตให้แก้ไข "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }